class FacetsDrawer extends SidebarDrawer {
    constructor() {
      super();
  
      this.setFacetsIconAccessibility();
    }
  
    setFacetsIconAccessibility() {
      const facetsLink = document.querySelector('#facets-icon-bubble');
      facetsLink.setAttribute('role', 'button');
      facetsLink.setAttribute('aria-haspopup', 'dialog');
      facetsLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(facetsLink);
      });
      facetsLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(facetsLink);
        }
      });
    }
  }
  
  customElements.define('facets-drawer', FacetsDrawer);
  